var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/lock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M12.0001 17.3498C12.9003 17.3498 13.6301 16.6201 13.6301 15.7198C13.6301 14.8196 12.9003 14.0898 12.0001 14.0898C11.0999 14.0898 10.3701 14.8196 10.3701 15.7198C10.3701 16.6201 11.0999 17.3498 12.0001 17.3498Z",
    fill: "#C9F032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.65 9.43945H7.35C3.25 9.43945 2 10.6895 2 14.7895V16.6495C2 20.7495 3.25 21.9995 7.35 21.9995H16.65C20.75 21.9995 22 20.7495 22 16.6495V14.7895C22 10.6895 20.75 9.43945 16.65 9.43945ZM12 18.7395C10.33 18.7395 8.98 17.3795 8.98 15.7195C8.98 14.0595 10.33 12.6995 12 12.6995C13.67 12.6995 15.02 14.0595 15.02 15.7195C15.02 17.3795 13.67 18.7395 12 18.7395Z",
    fill: "#C9F032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M7.12021 9.45V8.28C7.12021 5.35 7.95021 3.4 12.0002 3.4C16.0502 3.4 16.8802 5.35 16.8802 8.28V9.45C17.3902 9.46 17.8502 9.48 18.2802 9.54V8.28C18.2802 5.58 17.6302 2 12.0002 2C6.37021 2 5.72021 5.58 5.72021 8.28V9.53C6.14021 9.48 6.61021 9.45 7.12021 9.45Z",
    fill: "#C9F032"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e00795012fb5ffca7eb70af3acf160f3.svg";
export { ForwardRef as ReactComponent };